import { isAuthenticatedUser } from 'js/lib/user';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import PATHWAY_SLUGS from 'bundles/unified-description-page-common/constants/pathways';

/**
 * @description Enable pathways for NAMER region only
 */
export const showPathwaysNamer = () => {
  return GrowthDiscoveryEpicClient.get('showPathwaysNAMER');
};

/**
 * @description Enable pathways for logged in users
 */
export const showPathwaysUserBased = () => {
  return showPathwaysNamer() || GrowthDiscoveryEpicClient.get('showPathwaysGlobalHoldout2025');
};

/**
 * @description Returns whether the slug is a pathways slug
 */
export const isPathwaysXDP = (slug: string) => {
  return PATHWAY_SLUGS.includes(slug);
};

/**
 * @description Returns whether the pathways section on the XDP should be shown
 */
export const showPathwaysXDP = (slug: string) => {
  if (!slug || !PATHWAY_SLUGS.includes(slug)) {
    return false;
  }

  if (isAuthenticatedUser() && !showPathwaysUserBased()) {
    return false;
  }

  return true;
};

/**
 * @description Returns whether the pathways section on the Career Academy should be shown
 */
export const showPathwaysCareerAcademyPages = () => {
  if (isAuthenticatedUser() && !showPathwaysUserBased()) {
    return false;
  }

  return true;
};

/**
 * @description Returns whether the onboarding flow should be retriggered for exisiting users
 */
export const isInPathwaysRetriggerEpics = () =>
  (GrowthDiscoveryEpicClient.get('retriggerNamerOnboarding') && GrowthDiscoveryEpicClient.get('showPathwaysNAMER')) ||
  GrowthDiscoveryEpicClient.get('showPathwaysGlobalHoldout2025');
